import { postJSON } from 'bv-fetch';
import paramsPresenter from './presenters/submit_params_presenter';
import presentLuckyDipSettings from './presenters/lucky_dip_settings_presenter';

export const placeBet = (params) => postJSON('/api/lucky_dips/place_bet', paramsPresenter(params));

export const fetchLuckyDipSettings = (id) => postJSON(`/api/lucky_dips/${id}`)
  .then(presentLuckyDipSettings)
  .catch(presentLuckyDipSettings);
